export default __webpack_public_path__ + "static/media/little-fish.fecf495f.webp";